export const iconButton = (theme) => ({
    /* Styles applied to the root element. */
    root: {
        display: "flex",
        margin: 0,
    },
    icon: {
        width: 20,
        height: 20,
    },
});
